import React, { useEffect, useState } from "react";
import { API_URL } from "../../constants/appConfig";
import myToast from "../../components/toast";
import {
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Paper,
  Tooltip,
  Chip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";

export default function CategoryTable({ currentTab }) {
  const [categories, setCategories] = useState([]);
  const [selectedMainCategory, setSelectedMainCategory] = useState({});
  const [selectedDeleteMainCategory, setSelectedDeleteMainCategory] = useState(
    {}
  );
  const [selectedDeleteSubCategory, setSelectedDeleteSubCategory] = useState(
    {}
  );
  const [selectedSubCategory, setSelectedSubCategory] = useState({});
  const getAllCategory = async () => {
    try {
      const API = API_URL + "/fullCategory/getAllFullCategory";
      const response = await fetch(API);
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.log("error", error);
    }
  };
  const [openMainUpdate, setOpenMainUpdate] = React.useState(false);
  const handleOpenMainModal = () => setOpenMainUpdate(!openMainUpdate);
  const [openSubUpdate, setOpenSubUpdate] = React.useState(false);
  const handleOpenSubModal = () => setOpenSubUpdate(!openSubUpdate);
  const [openMainDelete, setOpenMainDelete] = React.useState(false);
  const handleOpenMainDelete = () => setOpenMainDelete(!openMainDelete);
  const [openSubDelete, setOpenSubDelete] = React.useState(false);
  const handleOpenSubDelete = () => setOpenSubDelete(!openSubDelete);
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const handleAccordionChange = (categoryId) => (event, isExpanded) => {
    setExpanded(isExpanded ? categoryId : false);
  };

  useEffect(() => {
    getAllCategory();
  }, []);
  const handleDeleteMainCategory = async (category) => {
    setOpenMainDelete(true);
    setSelectedDeleteMainCategory(category);
  };
  const handleDeleteSubCategory = async (subcategory) => {
    setOpenSubDelete(true);
    setSelectedDeleteSubCategory(subcategory);
  };
  const handleDeleteSubCategoryData = async () => {
    try {
      const API = `${API_URL}/subCategory/deleteSubCategoryById?subCategoryId=${selectedDeleteSubCategory.subcategoryId}`;
      const response = await fetch(API, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        myToast({ status: "success", message: "Alt Kategori Silindi" });
        getAllCategory();
        handleOpenSubDelete();
      } else {
        myToast({ status: "error", message: "Alt Kategori Silinemedi" });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleDeleteMainCategoryData = async () => {
    try {
      const API = `${API_URL}/category/deleteCategoryById?categoryId=${selectedDeleteMainCategory.categoryId}`;
      const response = await fetch(API, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        myToast({ status: "success", message: "Ana Kategori Silindi" });
        getAllCategory();
        handleOpenMainDelete();
      } else {
        myToast({ status: "error", message: "Ana Kategori Silinemedi" });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleUpdateMainCategory = async (category) => {
    setSelectedMainCategory(category);
    handleOpenMainModal();
  };
  const handleUpdateMainCategoryData = async () => {
    try {
      const API = API_URL + "/category/saveCategory";
      const response = await fetch(API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(selectedMainCategory),
      });
      const data = await response.json();
      if (data) {
        myToast({ status: "success", message: "Kategori Güncellendi" });
        getAllCategory();
        handleOpenMainModal();
      } else {
        myToast({ status: "error", message: "Kategori Güncellemedi" });
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleUpdateSubCategory = async (subcategory, categoryId) => {
    setSelectedSubCategory({
      ...subcategory,
      subcategoryCategoryFk: categoryId,
    });
    handleOpenSubModal();
  };

  const handleUpdateSubCategoryData = async () => {
    try {
      const API = API_URL + "/subCategory/saveSubCategory";
      const response = await fetch(API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(selectedSubCategory),
      });
      const data = await response.json();
      if (data) {
        myToast({ status: "success", message: "Alt Kategori Güncellendi" });
        getAllCategory();
        handleOpenSubModal();
      } else {
        myToast({ status: "error", message: "Alt Kategori Güncellemedi" });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const filteredCategories = categories.filter(category => {
    if (currentTab === 0) return true; // Tüm kategoriler
    if (currentTab === 1) return category.currency === true; // Altın kategorileri
    if (currentTab === 2) return category.currency === false; // Döviz kategorileri
    return true;
  });

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {filteredCategories.map((category) => (
          <Paper
            key={category.categoryId}
            elevation={expanded === category.categoryId ? 2 : 1}
            sx={{
              borderRadius: 2,
              overflow: 'hidden',
              transition: 'all 0.3s ease',
              border: '1px solid',
              borderColor: 'divider',
              '&:hover': {
                transform: { xs: 'none', md: 'translateY(-2px)' },
                boxShadow: 2
              }
            }}
          >
            {/* Ana Kategori Başlığı */}
            <Box
              onClick={() => setExpanded(expanded === category.categoryId ? false : category.categoryId)}
              sx={{
                p: { xs: 2, sm: 3 },
                cursor: 'pointer',
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: { xs: 'flex-start', md: 'center' },
                gap: { xs: 2, md: 0 },
                justifyContent: 'space-between',
                bgcolor: expanded === category.categoryId ? 'primary.lighter' : 'background.paper',
                borderBottom: expanded === category.categoryId ? 1 : 0,
                borderColor: 'divider',
                transition: 'all 0.3s ease'
              }}
            >
              <Box sx={{ flex: 1, width: { xs: '100%', md: 'auto' } }}>
                <Typography variant="h6" sx={{ 
                  fontWeight: 600, 
                  mb: 1,
                  fontSize: { xs: '1rem', sm: '1.25rem' }
                }}>
                  {category.categoryName}
                </Typography>
                <Typography 
                  variant="body2" 
                  color="text.secondary"
                  sx={{ 
                    display: { xs: 'none', sm: 'block' }
                  }}
                >
                  {category.categoryDescription}
                </Typography>
              </Box>

              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: { xs: 1, sm: 2, md: 3 },
                width: { xs: '100%', md: 'auto' },
                justifyContent: { xs: 'space-between', md: 'flex-end' },
                flexWrap: 'wrap'
              }}>
                <Chip 
                  label={`${category.subcategories?.length || 0} Alt Kategori`}
                  color="default"
                  size={isMobile ? "small" : "medium"}
                  sx={{ minWidth: { xs: '90px', sm: '110px' } }}
                />
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Tooltip title="Düzenle" arrow>
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleUpdateMainCategory(category);
                      }}
                      size={isMobile ? "small" : "medium"}
                      sx={{
                        color: 'primary.main',
                        '&:hover': { 
                          bgcolor: 'primary.main', 
                          color: 'white',
                          transform: { xs: 'none', md: 'scale(1.1)' },
                        },
                        transition: 'all 0.2s'
                      }}
                    >
                      <EditIcon fontSize={isMobile ? "small" : "medium"} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Sil" arrow>
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteMainCategory(category);
                      }}
                      size={isMobile ? "small" : "medium"}
                      sx={{
                        color: 'error.main',
                        '&:hover': { 
                          bgcolor: 'error.main', 
                          color: 'white',
                          transform: { xs: 'none', md: 'scale(1.1)' },
                        },
                        transition: 'all 0.2s'
                      }}
                    >
                      <DeleteIcon fontSize={isMobile ? "small" : "medium"} />
                    </IconButton>
                  </Tooltip>
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      setExpanded(expanded === category.categoryId ? false : category.categoryId);
                    }}
                    size={isMobile ? "small" : "medium"}
                    sx={{
                      transform: expanded === category.categoryId ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease'
                    }}
                  >
                    <ExpandMoreIcon fontSize={isMobile ? "small" : "medium"} />
                  </IconButton>
                </Box>
              </Box>
            </Box>

            {/* Alt Kategoriler */}
            <Box
              sx={{
                maxHeight: expanded === category.categoryId ? '1000px' : 0,
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                bgcolor: 'grey.50'
              }}
            >
              {category.subcategories?.map((sub, index) => (
                <Box
                  key={sub.subcategoryId}
                  sx={{
                    py: { xs: 2, sm: 3 },
                    px: { xs: 2, sm: 4 },
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    gap: { xs: 2, sm: 0 },
                    justifyContent: 'space-between',
                    borderBottom: index !== category.subcategories.length - 1 ? 1 : 0,
                    borderColor: 'divider',
                    '&:hover': { 
                      bgcolor: 'background.paper',
                      transform: { xs: 'none', md: 'translateX(10px)' }
                    },
                    transition: 'all 0.2s ease'
                  }}
                >
                  <Box sx={{ flex: 1, pl: { xs: 0, sm: 2 } }}>
                    <Typography 
                      variant="subtitle1" 
                      sx={{ 
                        fontWeight: 500, 
                        mb: 0.5,
                        fontSize: { xs: '0.9rem', sm: '1rem' }
                      }}
                    >
                      {sub.subcategoryName}
                    </Typography>
                    <Typography 
                      variant="body2" 
                      color="text.secondary"
                      sx={{ 
                        display: { xs: 'none', sm: 'block' }
                      }}
                    >
                      {sub.subcategoryDescription}
                    </Typography>
                  </Box>
                  <Box sx={{ 
                    display: 'flex', 
                    gap: 1,
                    width: { xs: '100%', sm: 'auto' },
                    justifyContent: { xs: 'flex-end', sm: 'flex-end' }
                  }}>
                    <Tooltip title="Düzenle" arrow>
                      <IconButton
                        onClick={() => handleUpdateSubCategory(sub, category.categoryId)}
                        size={isMobile ? "small" : "medium"}
                        sx={{
                          color: 'info.main',
                          '&:hover': { 
                            bgcolor: 'info.main', 
                            color: 'white',
                            transform: { xs: 'none', md: 'scale(1.1)' },
                          },
                          transition: 'all 0.2s'
                        }}
                      >
                        <EditIcon fontSize={isMobile ? "small" : "medium"} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Sil" arrow>
                      <IconButton
                          onClick={() => handleDeleteSubCategory(sub)}
                        size={isMobile ? "small" : "medium"}
                        sx={{
                          color: 'error.main',
                          '&:hover': { 
                            bgcolor: 'error.main', 
                            color: 'white',
                            transform: { xs: 'none', md: 'scale(1.1)' },
                          },
                          transition: 'all 0.2s'
                        }}
                      >
                        <DeleteIcon fontSize={isMobile ? "small" : "medium"} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              ))}
              {category.subcategories?.length === 0 && (
                <Box sx={{ p: { xs: 2, sm: 4 }, textAlign: 'center' }}>
                  <Typography color="text.secondary">
                    Bu kategoride henüz alt kategori bulunmamaktadır.
                  </Typography>
                </Box>
              )}
            </Box>
          </Paper>
        ))}
      </Box>

      {/* Ana Kategori Güncelleme Dialog */}
      <Dialog 
        open={openMainUpdate} 
        onClose={handleOpenMainModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Ana Kategori Güncelle</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <TextField
              fullWidth
              label="Ana Kategori Adı"
              value={selectedMainCategory?.categoryName || ''}
                  onChange={(e) =>
                    setSelectedMainCategory({
                      ...selectedMainCategory,
                      categoryName: e.target.value,
                    })
                  }
              size="small"
            />
            <TextField
              fullWidth
              label="Ana Kategori Açıklama"
              value={selectedMainCategory?.categoryDescription || ''}
              onChange={(e) =>
                    setSelectedMainCategory({
                      ...selectedMainCategory,
                      categoryDescription: e.target.value,
                })
              }
              size="small"
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button onClick={handleOpenMainModal} color="inherit">
            İptal
              </Button>
          <Button onClick={handleUpdateMainCategoryData} variant="contained">
            Kaydet
              </Button>
        </DialogActions>
          </Dialog>

      {/* Alt Kategori Güncelleme Dialog */}
      <Dialog 
        open={openSubUpdate} 
        onClose={handleOpenSubModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Alt Kategori Güncelle</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <TextField
              fullWidth
              label="Alt Kategori Adı"
              value={selectedSubCategory?.subcategoryName || ''}
                  onChange={(e) =>
                    setSelectedSubCategory({
                      ...selectedSubCategory,
                      subcategoryName: e.target.value,
                    })
                  }
              size="small"
            />
            <TextField
              fullWidth
              label="Alt Kategori Açıklama"
              value={selectedSubCategory?.subcategoryDescription || ''}
              onChange={(e) =>
                setSelectedSubCategory({
                      ...selectedSubCategory,
                      subcategoryDescription: e.target.value,
                })
              }
              size="small"
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button onClick={handleOpenSubModal} color="inherit">
            İptal
          </Button>
          <Button onClick={handleUpdateSubCategoryData} variant="contained">
            Kaydet
          </Button>
        </DialogActions>
      </Dialog>

      {/* Silme Dialogları */}
      <Dialog open={openMainDelete} onClose={handleOpenMainDelete}>
        <DialogContent sx={{ pt: 2, minWidth: 400 }}>
          <Typography variant="h6" align="center" gutterBottom>
            Ana Kategori Sil
          </Typography>
          <Typography align="center">
            {selectedDeleteMainCategory?.categoryName} isimli ana kategoriyi
            silmek istediğinize emin misiniz?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button onClick={handleOpenMainDelete} color="inherit">
            İptal
          </Button>
          <Button onClick={handleDeleteMainCategoryData} variant="contained" color="error">
            Sil
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openSubDelete} onClose={handleOpenSubDelete}>
        <DialogContent sx={{ pt: 2, minWidth: 400 }}>
          <Typography variant="h6" align="center" gutterBottom>
            Alt Kategori Sil
          </Typography>
          <Typography align="center">
            {selectedDeleteSubCategory?.subcategoryName} isimli alt kategoriyi
            silmek istediğinize emin misiniz?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button onClick={handleOpenSubDelete} color="inherit">
            İptal
              </Button>
          <Button onClick={handleDeleteSubCategoryData} variant="contained" color="error">
            Sil
              </Button>
        </DialogActions>
          </Dialog>
    </Box>
  );
}
